<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-12 16:16:52
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-date-picker v-model="timeArr"
                                type="daterange"
                                align="right"
                                start-placeholder="开始时间"
                                end-placeholder="截止时间"
                                :default-time="['00:00:00', '23:59:59']"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.community_id"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                    <el-option v-for="item in optionList"
                               :key="item.id"
                               :label="item.commName"
                               :value="item.id" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        @click="searchClick(1)"
                        icon="el-icon-search"
                >
                    今日
                </el-button>
                <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        @click="searchClick(2)"
                        icon="el-icon-search"
                >
                    本周
                </el-button>
                <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        @click="searchClick(3)"
                        icon="el-icon-search"
                >
                    本月
                </el-button>
                <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        @click="searchClick(0)"
                        icon="el-icon-search"
                >
                    查询
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <div >
                <span>
                            注册总人数:{{zongzhuce}}
                </span>
                <span style="margin-left: 100px">
                            活跃用户数:{{zonghuoyue}}
                </span>
                <span style="margin-left: 100px">
                            活跃用户百分比:{{zonghuoyuelv}}
                </span>

            </div>
            <el-table
                    v-loading="listLoading"
                    :data="tableData"
                    size="mini"
                    style="width: 100%; min-height: 300px;margin-top: 20px"
            >
                <el-table-column prop="commName" label="项目" min-width="200" />
                <el-table-column prop="zhuce_num" label="注册人数" width="200" />
                <el-table-column prop="huoyue_num" label="活跃人数" width="200" />
                <el-table-column prop="huoyue_rate" label="活跃率" width="200" />
            </el-table>
        </div>
    </div>
</template>

<script>
  import fetch from "@/api/tianzheng/member";
  import Qu from "@/api/tianzheng/Qu";
  import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
  export default {
    data() {
      return {
        optionList: [],
        queryParam: {
          name: "",
          phone: "",
          page: 1,
          size: 10,
          community_id:''
        },
        total: 0,
        listLoading: false,
        tableData: [],
        isEdit: 0, // 0新增 1编辑
        showDrawer: false,
        zongzhuce:0,
        zonghuoyue:0,
        zonghuoyuelv:0,
        timeArr:[]
      };
    },
    components: {
      Pagination,
    },
    created() {
      this.getList();
      this.getSelectCity()
    },
    mounted() {

    },
    methods: {
      // 获取下拉列表
      getSelectCity () {
        Qu.select({}).then(res => {
          if (res.code == 200) {
            this.optionList = res.result;
          }
        })
      },
      /* 查询按钮，页码重置，查询数据 */
      searchClick(timeparam) {
        var today = new Date();
        if(timeparam == 1){
          var begin = today.getFullYear()+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+("0" + today.getDate()).slice(-2);
            var end = begin;
          this.queryParam.begin_at = begin;
          this.queryParam.end_at = end;
          this.timeArr = [];
          this.timeArr.push(begin);
          this.timeArr.push(end);
        }else if (timeparam == 2){
          var firstDay = this.getMonday();
          var lastday = today.getFullYear()+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+("0" + today.getDate()).slice(-2);
          this.queryParam.begin_at = firstDay;
          this.queryParam.end_at = lastday;
          this.timeArr = [];
          this.timeArr.push(firstDay);
          this.timeArr.push(lastday);
        }else if (timeparam == 3){
          var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          var lastday = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.queryParam.begin_at = firstDay.getFullYear()+'-'+("0" + (firstDay.getMonth() + 1)).slice(-2)+'-'+("0" + firstDay.getDate()).slice(-2);
          this.queryParam.end_at = lastday.getFullYear()+'-'+("0" + (lastday.getMonth() + 1)).slice(-2)+'-'+("0" + lastday.getDate()).slice(-2);
          this.timeArr = [];
          this.timeArr.push(firstDay);
          this.timeArr.push(lastday);
        }else{
          if (this.timeArr !== '' && this.timeArr !== null && this.timeArr !== undefined) {
            this.queryParam.begin_at = this.timeArr[0]
            this.queryParam.end_at = this.timeArr[1]
          } else {
            this.queryParam.begin_at = ''
            this.queryParam.end_at = ''
          }
        }
        this.getList();
      },
      getMonday() {
        var now = new Date();
        var nowTime = now.getTime();
        var day = now.getDay();
        var longTime = 24 * 60 * 60 * 1000;
        var n = longTime * 7 * 0;
        var dd = nowTime - (day - 1) * longTime + n;
        dd = new Date(dd);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1;
        var d = dd.getDate();
        m = m < 10 ? "0" + m : m;
        d = d < 10 ? "0" + d : d;
        var day = y + "-" + m + "-" + d;
        return day;
      },
      /* 查询tableData数据 */
      getList() {
        let that = this;
        this.listLoading = true;
        fetch.huoyue(that.queryParam).then((res) => {
          that.listLoading = false;
          that.tableData = res.result.list;
          that.zongzhuce = res.result.zongzhuce;
          that.zonghuoyue = res.result.zonghuoyue;
          that.zonghuoyuelv = res.result.zonghuoyuelv;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
    .app-container {
        min-height: calc(100vh - 98px);
    }
</style>
